//
//
//
//
//
//
//
//
//
//
//
//

  import GDialog from "@/common/components/g-dialog/"
  export default {
    components: { GDialog },
    props: {
      show: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      handleJump(v) {
        this.$emit('close', true) // 关闭弹框
        if (v === -1) this.$router.go(v)
        if (v !== -1) this.$router.replace({ path: '/My/latest-deposit'})
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/SaveMonery/components/no-pay-dialog.vue